import classNames from 'classnames'
import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'
import { CrudStoreItemScout } from 'legacy/lut/classes/models/CrudStoreItemScout'
import { IFormPartnerFlagsRequests } from 'legacy/lut/classes/models/IFormPartnerFlagsRequests'
import { IFormSearchCodes } from 'legacy/lut/classes/models/IFormSearchCodes'
import { CrudStoreItemOnboarding } from 'legacy/lut/classes/models/onboarding/CrudStoreItemOnboarding'
import { parseArray } from 'legacy/lut/components/widgets/public/onboarding/helpers/parsers'
import React, { useEffect, useState } from 'react'

import { Button } from 'core-components/library/button'
import { Checkbox } from 'core-components/library/checkbox'
import { Loader } from 'core-components/library/loader'
import { IFilter, Logic, Operator } from 'core-components/types'
import { toServerFormat } from 'core/classes/helpers/DateHelper'
import { VisualAudience } from 'core/components/shared/ui/VisualAudience'
import { CrudStore } from 'core/types/crudStore'

import styles from './PowerCriteria.module.scss'

interface IProps {
  PartnerID: string
  fields: ICriteriaFiels[]
  flexWidth?: string
  rid: number
  appSource: string
}

interface ICriteriaFiels {
  label: string
  code: string
  addition?: string
  onlyOptIn?: boolean
  onlyOptOut?: boolean
  Source?: string
}

interface IPartnerAction {
  [key: string]: IPartnerStatus
}

interface IPartnerStatus {
  Action: string
  Status: string
  EntryId: number
}

interface IPfpFlagParams {
  EntryId519: number
  Code: string
}
export const CriteriaForm = ({ PartnerID, fields, flexWidth, rid, appSource }: IProps) => {
  const crudCodes = CrudStore.get(CrudStoreItemScout.WW_PartnerFlags, 'Criteria Form')
  const crudActions = CrudStore.get(CrudStoreItem.PartnerFlagsRequests, 'Criteria Form')

  const crudPfpInfo = CrudStore.get(CrudStoreItemOnboarding.PFPOnboardingRequests, 'Criteria Form')

  const [flagAdded, setFlagAdded] = useState<IObjectAny>({} as IObjectAny)
  const [partnerActions, setPartnerActions] = useState<IPartnerAction>({} as IPartnerAction)
  const [initialFlags, setInitialFlags] = useState<IPfpFlagParams[]>([])
  const [wip, setWip] = useState(false)

  const addFilters = () => {
    const filters: IFilter[] = []
    fields.forEach(
      (item: any) =>
        item.code &&
        filters.push({
          field: 'Code',
          value: item.code,
          operator: Operator.CONTAINS,
        })
    )
    crudCodes.setFilter({
      logic: Logic.AND,
      filters: [
        {
          field: 'PARTNER_ID',
          value: PartnerID,
          operator: Operator.EQUAL,
        },
        {
          logic: Logic.OR,
          filters,
        },
      ],
    })
    crudActions.setFilter({
      logic: Logic.AND,
      filters: [
        {
          field: 'PartnerId',
          value: PartnerID,
          operator: Operator.EQUAL,
        },
        {
          field: 'Status',
          value: 'Done',
          operator: Operator.EQUAL,
        },
        {
          logic: Logic.OR,
          filters,
        },
      ],
    })
    crudPfpInfo.setFilter({
      logic: Logic.AND,
      filters: [
        {
          field: 'RequestId',
          value: rid,
          operator: Operator.EQUAL,
        },
      ],
    })
  }

  const fetch = async () => {
    setWip(true)
    const responseCodes = await crudCodes.fetch()
    const newflagAdded: IObjectAny = {}
    if (responseCodes.items) {
      responseCodes.items.forEach((item: IFormSearchCodes) => {
        newflagAdded[item.Code || ''] = 1
      })
    }
    setFlagAdded(newflagAdded)

    const responseActions = await crudActions.fetch()
    const newPartnerActions: IPartnerAction = {}
    if (responseActions.items) {
      responseActions.items.forEach((item: IFormPartnerFlagsRequests) => {
        newPartnerActions[item.Code || ''] = {
          EntryId: item.EntryId ? +item.EntryId : -1,
          Action: item.Action || '',
          Status: item.Status || '',
        }
      })
    }
    const pfpData = await crudPfpInfo.fetch()
    const criteriaParams =
      pfpData.items.length && pfpData.items[0]
        ? parseArray(pfpData.items[0].SubmitCriteriaParams)
        : []
    const flagsParams = criteriaParams.length ? parseArray(criteriaParams[0].FlagsParams) : []
    setInitialFlags(flagsParams)
    setPartnerActions(newPartnerActions)
    setWip(false)
  }

  useEffect(() => {
    addFilters()
    fetch()
    return crudActions.subscribe('change', () => {
      fetch()
    })
  }, [])

  const onAdd = async (item: ICriteriaFiels, code: string, deleteCode: string) => {
    onRemove(item, deleteCode)
    partnerActions[code] &&
      partnerActions[code].Action === 'Remove' &&
      (await crudActions.delete('519', partnerActions[code]))
    await crudActions.create('519', [
      {
        Status: 'New',
        Type: 'Program',
        Action: 'Add',
        Code: code,
        CodeName: `${item.label} ${code.includes('OPTIN') ? ' Opt-In' : ' Opt-Out'}`,
        PartnerId: PartnerID,
        StartDate: toServerFormat(new Date()),
        EndDate: toServerFormat(new Date(2021, 9, 31)),
        Source: appSource,
      },
    ])
  }

  const onRemove = async (item: ICriteriaFiels, code: string) => {
    partnerActions[code] &&
      partnerActions[code].Action === 'Add' &&
      (await crudActions.delete('519', partnerActions[code]))
    flagAdded[item.code] &&
      (await crudActions.create('519', [
        {
          Status: 'New',
          Type: 'Program',
          Action: 'Remove',
          Code: code,
          CodeName: `${item.label} ${code.includes('OPTIN') ? ' Opt-In' : ' Opt-Out'}`,
          PartnerId: PartnerID,
          StartDate: toServerFormat(new Date()),
          EndDate: toServerFormat(new Date(2021, 9, 31)),
          Source: appSource,
        },
      ]))
  }

  const widthClass = () => {
    switch (flexWidth) {
      case '1/12':
      case '2/12':
      case '3/12':
      case '4/12':
      case '5/12':
      case '6/12':
        return styles['size-6']
    }
    return ''
  }

  const audienceButtons = (item: ICriteriaFiels, code: string, optIn: boolean = false) => {
    return partnerActions[code] && partnerActions[code].Action === 'Add' ? (
      <Button
        margin={'sm'}
        color={'danger'}
        disabled={!(partnerActions[code] && partnerActions[code].Action === 'Add')}
        onClick={async () => {
          setWip(true)
          onRemove(item, code)
          setWip(false)
        }}
      >
        {`Remove ${optIn ? 'Opt-In' : 'Opt-Out'}`}
      </Button>
    ) : (
      <Button
        margin={'sm'}
        onClick={async () => {
          setWip(true)
          onAdd(item, code, optIn ? `${item.code}_OPTOUT` : `${item.code}_OPTIN`)
          setWip(false)
        }}
      >
        {`Add ${optIn ? 'Opt-In' : 'Opt-Out'}`}
      </Button>
    )
  }
  const rowInfo = (
    item: ICriteriaFiels,
    partnerWithCode: IPartnerStatus,
    optIn: boolean,
    key: number
  ) => {
    return (
      <tr className={styles.tableRow} key={key}>
        <td>
          <div>{item.label}</div>
          {item.addition && <div className={styles.addition}>{item.addition}</div>}
        </td>

        <td>
          {item.code && (
            <VisualAudience
              write={['SuperAdmin']}
              read={['SuperAdmin']}
              component={() => (
                <div className={styles.audienseButtons}>
                  {!item.onlyOptOut && audienceButtons(item, `${item.code}_OPTIN`, true)}
                  {!item.onlyOptIn && audienceButtons(item, `${item.code}_OPTOUT`, false)}
                </div>
              )}
            />
          )}
        </td>
        {partnerWithCode &&
        (partnerWithCode.Action === 'Add' || partnerWithCode.Status === 'Done') ? (
          <td>{optIn ? 'Opt-In' : 'Opt-Out'}</td>
        ) : (
          <td className={styles.emptyCell} />
        )}
        {item.code &&
        partnerWithCode &&
        (partnerWithCode.Action === 'Add' || partnerWithCode.Status === 'Done') ? (
          <td>
            <p className={styles.mobileLabel}>Collaboration Commitment</p>
            <Checkbox
              padding
              label={optIn ? 'Yes' : 'No'}
              disabled
              checked={partnerWithCode.Action === 'Add' || partnerWithCode.Status === 'Done'}
            />
          </td>
        ) : (
          <td className={styles.emptyCell} />
        )}
        {item.code && partnerWithCode ? (
          <td>
            <p className={styles.mobileLabel}>Profiling Progress</p>
            {partnerWithCode.Action} ({partnerWithCode.Status})
          </td>
        ) : (
          <td className={styles.emptyCell} />
        )}
        <td>
          <p className={styles.mobileLabel}>Flag added</p>
          {item.code && (
            <Checkbox
              padding
              label={'Yes'}
              disabled
              checked={
                optIn ? !!flagAdded[`${item.code}_OPTIN`] : !!flagAdded[`${item.code}_OPTOUT`]
              }
            />
          )}
        </td>
      </tr>
    )
  }

  return wip ? (
    <Loader />
  ) : (
    <div className={classNames(styles.root, widthClass())}>
      <table>
        <thead>
          <tr className={styles.tableRow}>
            <th />
            <th />
            <th />
            <th>Collaboration Commitment</th>
            <th>Profiling Progress</th>
            <th>Flag added</th>
          </tr>
        </thead>
        <tbody>
          {fields.map((item, key) => {
            const codeOptIn = `${item.code}_OPTIN`
            const codeOptOut = `${item.code}_OPTOUT`
            const itemFalgs = initialFlags
              .filter((el) => el.Code.includes(item.code))
              .sort((a, b) => a.EntryId519 - b.EntryId519)

            const isOptIn = itemFalgs.length && itemFalgs[0].Code === codeOptIn ? true : false
            const partnerWithCode = partnerActions[isOptIn ? codeOptIn : codeOptOut]
            return rowInfo(item, partnerWithCode, isOptIn, key)
          })}
        </tbody>
      </table>
    </div>
  )
}
